export default () => ({
  activeStep: 3,
  readyToValidate: false,
  stepRequest: 0,
  checkoutInfo: null,
  dpdPoint: null,
  inpostPoint: null,
  glsPoint: null,
  ppPoint: null,
  selectAllAgree: false,
  orderApprovalInfo: '',
  checkoutForm: {
    agreedCeneoTrustedOpinions: false,
    isIndividual: false,
    paymentMethod: '',
    companyName: '',
    taxId: '',
    firstName: '',
    lastName: '',
    userEmail: '',
    userNewsletterAgreement: false,
    userTermsOfUseAgreement: false,
    noteToOrder: '',
    createUserAccountAgreement: false,
    isDeliveryToAnotherAddress: false,
    eInvoiceAgreement: true,
    deliveryMethod: '',
    deliveryPointName: '',
    deliveryPointPni: '',
    address: {
      countryCode: '',
      streetWithNumber: '',
      city: '',
      zip: '',
      phone1: '',
    },
    deliveryAddress: {
      countryCode: '',
      streetWithNumber: '',
      city: '',
      zip: '',
      phone1: '',
      addressLine1: '',
    },
    insufficientStockDecision: '',
  },
  checkoutLoggedForm: {
    agreedCeneoTrustedOpinions: false,
    newDeliveryAddress: {
      countryCode: '',
      streetWithNumber: '',
      city: '',
      zip: '',
      phone1: '',
    },
    orderDeliveryDate: '',
    deliveryAddressId: null,
    paymentMethod: '',
    clientOrderNumber: '',
    isDeliveryAddressNew: false,
    eInvoiceAgreement: true,
    userNewsletterAgreement: false,
    noteToOrder: '',
    emailForPrepayment: '',
    deliveryMethod: '',
    deliveryPointName: '',
    deliveryPointPni: '',
    insufficientStockDecision: '',
    companyNameCompleted: '',
    companyStreetCompleted: '',
    companyZipCompleted: '',
    companyCityCompleted: '',
    userPhone: '',
    costCenterId: null,
  },
  orderSummary: {},
});
